module.exports = __webpack_public_path__ + "img/B-9.01e1686d.png";